class Countdown {
    constructor(element) {
        this.element = element;
        this.date = new Date(this.element.dataset.date).getTime() / 1000;

        this.count();

        this.interval = setInterval(() => {
            this.count();
        }, 1000);
    }

    count() {
        this.now = new Date().getTime() / 1000;

        const distance = this.date - this.now;

        const days = this.addZero(Math.floor(distance / (60 * 60 * 24)));
        let hours = Math.floor((distance % (60 * 60 * 24)) / (60 * 60));
        hours = this.addZero(hours);
        const minutes = this.addZero(Math.floor((distance % (60 * 60)) / (60)));

        this.daysElement = this.element.querySelector('.js-countdown-days');
        this.hoursElement = this.element.querySelector('.js-countdown-hours');
        this.minutesElement = this.element.querySelector('.js-countdown-minutes');

        this.daysElement.innerHTML = `${days}`;
        this.hoursElement.innerHTML = `${hours}`;
        this.minutesElement.innerHTML = `${minutes}`;

        if (distance < 0) {
            document.querySelector('.js-countdown').classList.add('hidden');
        }
    }

    // eslint-disable-next-line class-methods-use-this
    addZero(n) {
        return (n < 10) ? `0${n}` : n;
    }
}

const countdown = {
    init() {
        const element = document.querySelector('.js-countdown');

        if (element != null) {
            // eslint-disable-next-line no-new
            new Countdown(document.querySelector('.js-countdown'));
        }
    },
};

export default countdown;
